import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assign-standards',
  templateUrl: './assign-standards.component.html',
  styleUrls: ['./assign-standards.component.css']
})
export class AssignStandardsComponent implements OnInit {

  constructor(public assignUserModal: NgbActiveModal) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/standards-management/modals/assign-standards/assign-standards.component.ts